export default {
    all: { method: 'GET', url: 'categoria/all' },
    active: { method: 'GET', url: 'categoria/active' },
    get: { method: 'GET', url: 'categoria/get{/id}' },
    create: { method: 'POST', url: 'categoria' },
    update: { method: 'PUT', url: 'categoria' },
    inactive: { method: 'DELETE', url: 'categoria/{/id}' },
};